import React from 'react';
import Add from '@material-ui/icons/Add';

export default ({ reasonForChange, descriptionOfChange }) => {
  return reasonForChange || descriptionOfChange ? 'RFC' : <Add />;
};
